import React from 'react';
import { Info } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
import { TIE_FORMATS } from '../generators/tieFormats';

/**
 * Shown whenever a generated schedule has at least one match between two
 * real 4-player team rosters (see tieFormats.hasEligibleTies) — offers
 * "Single match" (default, unchanged behavior) vs "MLP Slate" (expand that
 * tie into the fixed 5-game MLP slate). Format-agnostic: the same control
 * works for round_robin, cross_group, or any other structure, since tie
 * format is a property of individual matches, not of the tournament
 * structure that scheduled them.
 */
const TieFormatToggle = ({ value, onChange }) => {
  const { theme } = useTheme();
  return (
    <div className={`mb-4 flex flex-wrap items-center justify-between gap-3 rounded-xl border ${theme.border} ${theme.backgroundSecondary} px-4 py-3`}>
      <div className={`flex items-start gap-2 text-xs ${theme.textMuted}`}>
        <Info size={14} className="mt-0.5 shrink-0" />
        <span>
          Doubles ties between two 4-player team rosters can play as one match, or expand into the MLP
          (Major League Pickleball) 5-game slate.
        </span>
      </div>
      <div className={`inline-flex shrink-0 rounded-full border ${theme.border} p-1`}>
        {[
          { value: TIE_FORMATS.SINGLE_MATCH, label: 'Single match' },
          { value: TIE_FORMATS.MLP_SLATE, label: 'MLP Slate' },
        ].map((opt) => (
          <button
            key={opt.value}
            type="button"
            onClick={() => onChange(opt.value)}
            className={`rounded-full px-3.5 py-1.5 text-xs font-semibold transition-colors ${
              value === opt.value ? theme.buttonPrimary : `${theme.textSecondary} hover:${theme.text}`
            }`}
          >
            {opt.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default TieFormatToggle;
